import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/services';
import ActiveTemplate from './components/DraftTemplate';
import SelectLayout from './components/SelectLayout';
import TemplateSwitcher from './components/TemplateSwitcher';
import { useGetActiveTemplate } from './services';

const ShowcasePage = () => {
  const { refetch: getActivetemplate } = useGetActiveTemplate();
  const [draftTemplate, setDraftTemplate] = useState<any>([]);
  const newTemplate = useSelector<RootState, boolean>((state) => state.template.newTemplate);
  const selectedItem = useSelector<RootState, number>((state) => state.template.templateNumber);
  const merhcantTemplateId = useSelector<RootState, number>((state) => state.template.merchantTemplateId);
  useEffect(() => {
    const fetchData = async () => {
      const reponse = await getActivetemplate();
      setDraftTemplate(reponse.data?.activeTemplate);
    };

    fetchData();
  }, [merhcantTemplateId]);

  return (
    <>
      {newTemplate && selectedItem === 0 ? (
        <SelectLayout selectedTemplateId={selectedItem} />
      ) : draftTemplate && draftTemplate.length > 0 && selectedItem === 0 ? (
        <ActiveTemplate data={draftTemplate && draftTemplate} />
      ) : selectedItem === 0 ? (
        <SelectLayout selectedTemplateId={selectedItem} />
      ) : (
        <TemplateSwitcher selectedItem={selectedItem} />
      )}
    </>
  );
};

export default ShowcasePage;
